/**
 * Asynchronously loads the component for PiecripForgotPasswordPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripForgotPasswordPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripForgotPasswordPage,
);
